










import { Component, Prop, Vue } from 'vue-property-decorator';
import { RawLocation } from 'vue-router';

@Component
export default class PageOrganizationCard extends Vue {
  // Props
  @Prop({ type: Number, default: 0 })
  marginRight: number;

  @Prop({ type: Boolean, default: true })
  showEmpty: boolean;

  @Prop({ type: [String, Object], default: null })
  to: RawLocation;

  @Prop({ type: [Number], default: 0 })
  value: number;

  @Prop({ type: String, default: 'heart' })
  type: 'heart' | 'basket';

  // Computed
  get hasLink() {
    return !!this.to;
  }

  get isVisible() {
    const { showEmpty, value } = this;
    return showEmpty || (!showEmpty && value > 0);
  }

  get styles() {
    const { marginRight } = this;
    const styles: any = {};
    if (marginRight) styles.marginRight = [marginRight, 'px'].join('');
    return styles;
  }
}



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/parts/header/deferred/component.vue